import { useState, useEffect } from 'react';

/**
 * Hook para detectar se a aplicação está sendo visualizada em um dispositivo móvel.
 * Inclui suporte a SSR e atualiza automaticamente quando o tamanho da janela muda.
 * 
 * @param breakpoint Largura em pixels para considerar como "mobile" (padrão: 640px)
 * @returns Boolean indicando se a tela atual é considerada mobile
 */
export function useIsMobile(breakpoint = 640) {
  // Inicializar com false para evitar problemas com SSR (Server Side Rendering)
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    // Função para verificar o tamanho da tela
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };
    
    // Verificar inicialmente
    checkIfMobile();
    
    // Adicionar listener para mudanças de tamanho
    window.addEventListener('resize', checkIfMobile);
    
    // Limpar o listener quando o componente for desmontado
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, [breakpoint]);
  
  return isMobile;
}

export default useIsMobile; 